import React from 'react';

function Invoice3() {
  return (
    <>
      <section className="inv3-container">
        <h1 className="inv-H3">Manage Invoices</h1>
        <a className="All-3">All</a>
        <a className="pending-3">Pending</a>
        <a className="completed-3">Completed</a>
        <input type="text" name="search4" placeholder="Search" id="search4" className="search4" required />
        <h2 className="inv-H4">This Week</h2>
        <input type="text" name="INV5" placeholder="" id="INV9" className="INV9" required />
        <input type="text" name="INV6" placeholder="" id="INV10" className="INV10" required />
        <input type="text" name="INV7" placeholder="" id="INV11" className="INV11" required />
        <input type="text" name="INV8" placeholder="" id="INV12" className="INV12" required />
        <a className="back-home4" href="#">Back To Home</a>


      </section>
    </>
  );
}

export default Invoice3;
